/**
 * AdMob placement mirrors AdSense phone web:
 * - fixed-layout pages → bottom sticky banner
 * - InfiniteFeed browse pages → in-feed every N rows
 * - home + everything else → no ads
 */

export function getAdMobPlacement(pathname) {
    if (!pathname || pathname === '/') return 'none';

    // Fixed-layout AdSense pages (phone = bottom banner only)
    if (
        pathname === '/blog' ||
        pathname.startsWith('/blog/') ||
        pathname === '/additems' ||
        pathname.startsWith('/additems') ||
        pathname === '/addcollectible' ||
        pathname === '/addDiecast' ||
        pathname === '/addHeroCard' ||
        pathname === '/createmarketplaceitem'
    ) {
        return 'bottom';
    }

    // InfiniteFeed browse pages (in-feed adaptive banner)
    if (
        pathname === '/marketplace' ||
        pathname === '/searchcollectibles' ||
        pathname === '/searchDiecasts' ||
        pathname === '/searchHeroCards' ||
        pathname === '/myitems' ||
        pathname === '/mycollection' ||
        pathname === '/myHeroCardWishList' ||
        pathname.startsWith('/searchUsersCollection/')
    ) {
        return 'infeed';
    }

    return 'none';
}
